
import { defineComponent, reactive, watch } from "vue";
import { Ingrediente } from "@/api/interfacesReceita";
import ApiReceita from "@/api/apiReceita";
import toast from "@/core/toast";
export default defineComponent({
  Name: "FormIngrediente",
  props: {
    item: {
      type: Number,
      required: false
    }
  },
  setup(props, { emit }) {
    interface Cadastro {
      descricao: string;
      unidade?: string;
      quantidade?: number;
      preco?: number;
      update: boolean;
      item: Ingrediente;
    }
    const state = reactive({
      descricao: "",
      unidade: "",
      quantidade: undefined,
      preco: undefined,
      update: false,
      item: {} as Ingrediente
    }) as Cadastro;

    function resetaform() {
      state.descricao = "";
      state.unidade = "";
      state.quantidade = undefined;
      state.preco = undefined;
      state.update = false;
    }

    async function BuscaIngrediente() {
      const request = new ApiReceita();
      const id = props.item == null ? 0 : props.item;
      if (id > 0) {
        await request
          .buscaIngrediente(id)
          .then(response => {
            state.item = response;
          })
          .catch(err => {
            toast.error(err, "Ops");
          });
      }
    }

    async function CadastraIngrediente() {
      const ingrediente: Ingrediente = {
        descricao: state.descricao,
        unidade: state.unidade,
        quantidade: state.quantidade,
        preco: state.preco
      };
      const request = new ApiReceita();
      await request
        .createIngrediente(ingrediente)
        .then(() => {
          resetaform();
          toast.success("Cadastramos esse ingrediente pra você.", "Ótimo");
          emit("recarrega", true);
        })
        .catch(err => {
          resetaform();
          toast.error(err, "Ops");
        });
    }

    async function UpdateIngrediente() {
      state.item.descricao = state.descricao;
      state.item.quantidade = state.quantidade;
      state.item.preco = state.preco;
      state.item.unidade = state.unidade;
      const request = new ApiReceita();
      const id = state.item.id == null ? 0 : state.item.id;
      await request
        .updateIngrediente(state.item, id)
        .then(() => {
          toast.success("Atualizamos esse ingrediente pra você.", "Ótimo");
          emit("recarrega", true);
        })
        .catch(err => {
          toast.error(err, "Ops");
        })
        .finally(() => {
          resetaform();
        });
    }

    if (typeof props.item != "undefined") {
      BuscaIngrediente();
    } else {
      resetaform();
    }

    watch(
      () => props.item,
      () => {
        if (typeof props.item != "undefined") {
          BuscaIngrediente();
        } else {
          resetaform();
        }
        //console.log(props.item, state.update);
      }
    );

    watch(
      () => state.item,
      () => {
        if (typeof props.item != undefined) {
          state.descricao = state.item.descricao;
          state.quantidade = state.item.quantidade;
          state.preco = state.item.preco;
          state.unidade = state.item.unidade;
          state.update = true;
        }
      }
    );

    return {
      state,
      CadastraIngrediente,
      resetaform,
      BuscaIngrediente,
      UpdateIngrediente
    };
  }
});
